import { motion } from "framer-motion";
import Reveal from "@/components/Reveal";

const TESTIMONIALS = [
  {
    quote: "Inkaa built a platform that loaded before I could even blink. The SEO results were immediate.",
    author: "Sarah Chen",
    role: "CEO",
    company: "Nexus Labs"
  },
  {
    quote: "Their performance-first approach isn't just a marketing slogan. It's a fundamental engineering edge.",
    author: "David Miller",
    role: "CTO",
    company: "Vortex Fintech"
  },
  {
    quote: "The AEO optimization they did for us tripled our visibility in Perplexity and ChatGPT results.",
    author: "Elena Rodriguez",
    role: "Head of Growth",
    company: "Lumina AI"
  },
  {
    quote: "Savage speed. Savage results. They are the only team we trust with our high-traffic infrastructure.",
    author: "Marcus Thorne",
    role: "Founder",
    company: "Ironclad Security"
  },
  {
    quote: "Inkaa doesn't just build websites. They build competitive advantages.",
    author: "James Wilson",
    role: "Director of Marketing",
    company: "CloudScale"
  }
];

export default function TestimonialScroller() {
  const items = [...TESTIMONIALS, ...TESTIMONIALS];

  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      {/* Header - Fixed Z-index and Spacing */}
      <div className="max-w-7xl mx-auto px-6 mb-24 relative z-30">
        <Reveal>
          <span className="eyebrow">Trust</span>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display font-black uppercase tracking-tighter leading-[0.85] text-5xl md:text-7xl lg:text-8xl mt-5">
            The <span className="text-[#FF4500]">Conviction</span> <br />
            Of Our Partners.
          </h2>
        </Reveal>
      </div>

      {/* Scroller Container */}
      <div className="relative h-[600px] bg-[#050505] border-y border-white/5 z-20">
        {/* Top and Bottom Fades - Increased contrast and height */}
        <div className="absolute top-0 left-0 right-0 h-48 bg-gradient-to-b from-[#050505] via-[#050505]/90 to-transparent z-10 pointer-events-none" />
        <div className="absolute bottom-0 left-0 right-0 h-48 bg-gradient-to-t from-[#050505] via-[#050505]/90 to-transparent z-10 pointer-events-none" />

        <div className="h-full overflow-hidden">
          <motion.div 
            animate={{ 
              y: ["0%", "-50%"] 
            }}
            transition={{ 
              duration: 40, 
              repeat: Infinity, 
              ease: "linear" 
            }}
            className="flex flex-col gap-16 py-32"
          >
            {items.map((t, i) => (
              <div key={i} className="max-w-4xl mx-auto px-6 text-center space-y-8">
                <blockquote className="font-display text-3xl md:text-5xl font-bold uppercase tracking-tight text-white/90 leading-tight">
                  "{t.quote}"
                </blockquote>
                <div className="flex flex-col items-center gap-2">
                  <span className="text-[#FF4500] text-sm uppercase tracking-[0.4em] font-bold">
                    {t.author}
                  </span>
                  <span className="text-white/75 text-xs uppercase tracking-widest font-medium">
                    {t.role} — {t.company}
                  </span>
                </div>
                
                {/* Divider */}
                <div className="h-px w-24 bg-white/10 mx-auto mt-16" />
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
